<template>
  <div id="main-app">
    <ToastComp />
    <TopToolComp v-if="showTools" layout="split" />
    <router-view />
    <BottomToolComp v-if="showTools" layout="full" />
  </div>
</template>

<script>
import TopToolComp from '@/components/TopToolComp.vue';
import BottomToolComp from '@/components/BottomToolComp.vue';
import ToastComp from '@/components/ToastComp.vue';

export default {
  name: 'App',
  components: {
    TopToolComp,
    BottomToolComp,
    ToastComp
  },
  computed: {
    showTools() {
      if (this.$route.path.startsWith('/nakota')) {
        return false;
      }
      const excludedRoutes = ['/', '/clients/login', '/school/login'];
      return !excludedRoutes.includes(this.$route.path);
    }
  }
}
</script>

<style lang="less">
:root {
  --white: #ffffff;
  --black: #000000;
  --blue: #009eff;
  --orange: #f66606;
  --yellow: #fab800;
  --green: #24bd2e;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

a {
  -webkit-touch-callout: none;
}

::-webkit-scrollbar {
  display: none;
}

* {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

html,
body {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: var(--blue);

}

#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
</style>
